import type { Wallet, WalletWithRequiredFeatures } from '@mysten/wallet-standard';
import { WalletSlice, WalletSliceKey } from '../types/wallet-slice.type';
import type { AuthType } from '../types/auth-type.type';

export const WALLETS_INFO_STORAGE_KEY = 'suigar.connection.wallets';
export const WALLET_CONNECTION_ORDER: WalletSliceKey[] = ['suiWallet', 'zkLoginWallet'];

export function getWalletUniqueIdentifier(wallet?: Wallet) {
	return wallet?.id ?? wallet?.name;
}

export const findWalletByIdentifier = (wallets: WalletWithRequiredFeatures[], identifier: string) => {
	return wallets.find((wallet) => {
		const uniqueIdentifier = getWalletUniqueIdentifier(wallet);
		if (!uniqueIdentifier) {
			return false;
		}
		return uniqueIdentifier === identifier || wallet.name === identifier;
	});
};

export function hasResolvableConnection(slice: WalletSlice): boolean {
	return Boolean(
		(slice.currentWallet && (slice.currentAccount || slice.accounts.length > 0)) ||
		(slice.lastConnectedWalletName && slice.lastConnectedAccountAddress),
	);
}

export function resolveWalletSliceKey(authType?: AuthType | string | null): WalletSliceKey | null {
	if (!authType) {
		return null;
	}
	const normalized = authType.toString().toLowerCase();
	if (normalized === 'zklogin') {
		return 'zkLoginWallet';
	}
	if (normalized === 'wallet') {
		return 'suiWallet';
	}
	return null;
}
